// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__EUt1W","info":"UpdateTermsInfo_info__2pEIh"};